import { useQuery } from '@tanstack/react-query';

import { QUERY_APP_USER_STATUS_KEY } from '../../consts';

interface AppDownloadStatusResponse {
  hasDownloadedApp: boolean;
  recurringAppointmentsEnabled: boolean;
  healthieId: string | null;
}

const fetchAppUserStatus = async (
  clientId: string | number,
): Promise<AppDownloadStatusResponse> => {
  const response = await fetch(
    `/api/patient-app/external/user-status/${clientId}`,
  );
  if (!response.ok) {
    throw new Error('Failed to fetch app user status');
  }
  return response.json();
};

export const useGetAppUserStatus = (clientId?: string) => {
  return useQuery({
    queryKey: [QUERY_APP_USER_STATUS_KEY, clientId],

    queryFn: async () => {
      if (!clientId) {
        return {
          hasDownloadedApp: false,
          recurringAppointmentsEnabled: false,
          healthieId: null,
        };
      }
      return fetchAppUserStatus(clientId);
    },

    // 1 minute
    staleTime: 60000,

    // 1 minute
    gcTime: 60000,

    enabled: !!clientId,
  });
};
